import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "size_spots",
        object: "size_spot",
        header: [
            { text: "Titulo", value: "title" },
            { text: "Icono", value: "icon", sortable: false },
            { text: "Descripción", value: "description" },
            { text: "Orden", value: "order" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
